module.exports = __webpack_public_path__ + "static/media/user-times.cdc1f092.svg";